import { render, staticRenderFns } from "./AudioVolume.vue?vue&type=template&id=54237130&scoped=true&"
import script from "./AudioVolume.vue?vue&type=script&lang=js&"
export * from "./AudioVolume.vue?vue&type=script&lang=js&"
import style0 from "./AudioVolume.vue?vue&type=style&index=0&id=54237130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54237130",
  null
  
)

export default component.exports